import React, { useState } from "react";
import { ArrowUpRight, Mail, CalendarDays, PhoneCall } from "lucide-react";
import { useSelector } from "react-redux";
import { BookingSectionText } from "i18n/Events";
import CTAButton from "Util/CTAButton";
import { fadeUp } from "animations/variants";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BookSection = () => {
  const lang = useSelector((state) => state.language.lang);

  const navigate = useNavigate();

  const t = BookingSectionText[lang];
  const [expanded, setExpanded] = useState({});

  return (
    <section className="relative overflow-hidden py-20 lg:py-28 bg-[#0d0d0d]">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-reddark/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-500/10 rounded-full blur-[120px]" />
      </div>
      <div className="max-w-7xl mx-auto px-3 lg:px-6 ">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="
        relative
        rounded-[32px]
        border-0 lg:border border-white/10
        bg-none lg:bg-white/[0.1]
        backdrop-blur-xl
        p-0 py-10 lg:p-10 md:p-16
        text-center
        overflow-hidden 
      "
        >
          <div className="hidden lg:flex absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-reddark via-red-500 to-reddark" />

          <motion.div
            id="contact-form"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className=""
          >
            {" "}
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="flex items-center justify-center gap-4 mb-6 "
            >
              <span className="w-12 h-px bg-reddark" />
              <span className="uppercase tracking-[0.3em] text-sm text-white/80 font-medium">
                {t.sessionTitle}
              </span>
              <span className="w-12 h-px bg-reddark" />
            </motion.div>
            {/* <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="w-24 h-1 bg-reddark rounded-full mb-8 mx-auto"
            /> */}
            <div className="space-y-5">
              {t.sessions.map((session, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -4 }}
                  className="
                      group relative overflow-hidden
                      rounded-[2rem]
                      border border-white/10
             backdrop-blur-xl
                      p-6 md:p-8
                      shadow-[0_10px_40px_rgba(0,0,0,0.05)]
                      transition-all duration-500 bg-white/[0.1]
                    "
                >
                  <div className="absolute top-0 right-0 w-32 h-32 bg-reddark/5 blur-3xl rounded-full" />

                  <div className="relative z-10 grid lg:grid-cols-[1fr_auto] gap-8 items-start">
                    {" "}
                    <motion.div
                      whileHover={{ y: -6 }}
                      transition={{ duration: 0.3 }}
                      className="w-full"
                    >
                      <div
                        className="
      relative
      overflow-hidden
      rounded-3xl
      border border-white/10
      bg-white/5
      backdrop-blur-sm
      shadow-xl
      group
    "
                      >
                        {/* Image */}
                        <img
                          src={session.image}
                          alt={session.title}
                          className="
        w-full
        h-auto
        object-cover
        transition-transform
        duration-700
        group-hover:scale-105
      "
                        />

                        {/* Gradient overlay */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-80" />

                        {/* Bottom information */}
                        {/* <div className="absolute bottom-0 left-0 right-0 p-6">
                          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-md px-3 py-1 text-xs uppercase tracking-[0.2em] text-white">
                            <div className="h-2 w-2 rounded-full bg-reddark" />
                            Session {index + 1}
                          </div>

                          <h3 className="mt-4 font-[Crimson] text-2xl md:text-3xl text-white leading-tight">
                            {session.title}
                          </h3>

                          {session.duration && (
                            <p className="mt-2 text-sm text-white/80">
                              {session.duration}
                            </p>
                          )}
                        </div> */}
                      </div>

                      {/* Optional description */}
                      {session.top && (
                        <p className="mt-5 text-gray-300 leading-7">
                          {session.duration}
                        </p>
                      )}
                    </motion.div>
                    {/* <div className="flex flex-col items-start justify-start"> */}
                    {/* <div className="flex items-center gap-3 mb-3">
                        <div className="w-3 h-3 rounded-full bg-reddark" />

                        <span className="text-sm uppercase tracking-[0.2em] text-gray-200">
                          Session {index + 1}
                        </span>
                      </div> */}
                    {/* <h5 className="text-2xl md:text-3xl font-[Crimson] text-white leading-tight mb-3 text-left uppercase">
                        {session.title}
                      </h5> */}
                    {/* <p className="text-gray-400 text-base">
                        {session.duration}
                      </p> */}
                    {/* Top */}
                    {/* {session.top && (
                        <div className="max-w-3xl mt-4">
                          <p className="text-gray-200 text-left leading-7 font-medium">
                            {session.top}
                          </p>
                        </div>
                      )} */}
                    {/* Description */}
                    {/* {session.description && (
                        <div className="max-w-3xl mt-5">
                          <AnimatePresence initial={false}>
                            <motion.div
                              key={expanded[index] ? "expanded" : "collapsed"}
                              initial={{ opacity: 0.8 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 0.3 }}
                              className={`overflow-hidden whitespace-pre-line text-left leading-7 text-gray-300 ${
                                expanded[index] ? "" : "line-clamp-3"
                              }`}
                            >
                              {session.description}
                            </motion.div>
                          </AnimatePresence>

                          <motion.button
                            whileHover={{ x: 4 }}
                            whileTap={{ scale: 0.96 }}
                            onClick={() =>
                              setExpanded((prev) => ({
                                ...prev,
                                [index]: !prev[index],
                              }))
                            }
                            className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-white hover:border-reddark/40 hover:bg-reddark/10 transition-all"
                          >
                            <span>
                              {expanded[index]
                                ? lang === "vi"
                                  ? "Thu gọn"
                                  : "Show Less"
                                : lang === "vi"
                                  ? "Xem thêm"
                                  : "Read More"}
                            </span>

                            <motion.div
                              animate={{ rotate: expanded[index] ? 180 : 0 }}
                              transition={{ duration: 0.25 }}
                            >
                              <ChevronDown className="w-4 h-4 text-reddark" />
                            </motion.div>
                          </motion.button>
                        </div>
                      )} */}
                    {/* </div> */}
                    <CTAButton
                      variant="primary"
                      icon={PhoneCall}
                      text={session.button}
                      onClick={() => {
                        // paypal booking
                        if (session.link.startsWith("http")) {
                          window.open(session.link, "_blank");
                          return;
                        }

                        if (session.link === "email") {
                          navigate("/contact");
                          return;
                        }
                      }}
                    />
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default BookSection;
